// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  sessionId: __t.u64().name("session_id"),
  messageId: __t.u64().name("message_id"),
  sentenceIndex: __t.u32().name("sentence_index"),
  totalSentences: __t.u32().name("total_sentences"),
  mimeType: __t.string().name("mime_type"),
  sampleRate: __t.u32().name("sample_rate"),
  audioBytes: __t.byteArray().name("audio_bytes"),
  durationMs: __t.u32().name("duration_ms"),
  isFinal: __t.bool().name("is_final"),
  createdAt: __t.timestamp().name("created_at"),
  downloadUrl: __t.string().name("download_url"),
});
